import React, { forwardRef } from "react";

/** Classes for a standard text field; add FIELD_ERROR_CLASS when its value is invalid. */
export const FIELD_CLASS =
  "w-full h-13 border border-border rounded-sm px-4 text-base text-dark bg-surface placeholder:text-subtle focus:outline-none focus:border-primary transition-colors";
export const FIELD_ERROR_CLASS = "border-danger bg-danger-50";

const Index = forwardRef(({ type = "text", className = "", ...rest }, ref) => {
  const inputProps =
    type === "number"
      ? {
          inputMode: "numeric",
          pattern: "[0-9]*",
          ...rest,
        }
      : rest;

  return (
    <input
      ref={ref}
      type={type}
      className={` ${className} ${
        type === "number"
          ? "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
          : ""
      }`}
      {...inputProps}
    />
  );
});

export default Index;
